import React, { useEffect, useState } from 'react';
import "./Details.css";
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { eye } from 'react-icons-kit/feather/eye';
import { arrowUp } from 'react-icons-kit/feather/arrowUp';
import { arrowUpRight } from 'react-icons-kit/feather/arrowUpRight'
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
import { GetCustomerByPhone } from '../apiconfig/authService';
import { RiLoaderFill } from "react-icons/ri";

function ViewCustomer() {
    const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');

    const [customerData, setCustomerData] = useState([]);
    const { customerPhoneNumber } = useParams();
    const [loading, setLoading] = useState(false);

    const formatUTCDate = (utcDateString) => {
      const date = new Date(utcDateString);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 → 12, 13 → 1, etc.
      hours = String(hours).padStart(2, "0");

      return `${day}-${month}-${year} at ${hours}:${minutes}:${seconds} ${ampm}`;
    };

    useEffect(() => {
        (
            async () => {
                setLoading(true);
                try {
                    const response = await GetCustomerByPhone(customerPhoneNumber, localStorage.getItem('accessToken'));
                    setLoading(false);
                    setCustomerData(response.data);
                } catch (error) {
                    console.log(error);
                } finally {
                    setLoading(false);
                }
            }
        )();
    }, []);


    return (
        <div className="dashboard-content">
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Customer Management</h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="/customer" className="btn btn-primary addSeller"><Icon className="eye" icon={eye} size={18} /> View All</NavLink>
                    </div>
                </div>
                {loading ? (
                    <div className="d-flex align-items-center justify-content-center">
                        <RiLoaderFill
                            size={40}
                            className="text-success spin-animation text-center"
                        />
                    </div>
                ) : (
                    <div className="detailsBox">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <h4 className="text-primary h6 fw-bold">Customer Information</h4>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover w-100">
                                        <tbody>
                                            <tr>
                                                <th>Customer Name</th>
                                                <td>{customerData?.customer?.name}</td>
                                            </tr>
                                            <tr>
                                                <th>Customer Phone Number</th>
                                                <td>{customerData?.customer?.customerphone}</td>
                                            </tr>
                                            <tr>
                                                <th>Customer Email ID</th>
                                                <td>{customerData?.customer?.emailid}</td>
                                            </tr>
                                            <tr>
                                                <th>Created Date</th>
                                                <td>{formatUTCDate(customerData?.customer?.createddate)}</td>
                                            </tr>
                                            <tr>
                                                <th>Modified Date</th>
                                                <td>{formatUTCDate(customerData?.customer?.modifieddate)}</td>
                                            </tr>
                                            <tr>
                                                <th>Created By</th>
                                                <td>{customerData?.customer?.createdby}</td>
                                            </tr>
                                            <tr>
                                                <th>Modified By</th>
                                                <td>{customerData?.customer?.modifiedby}</td>
                                            </tr>
                                            {/* <tr>
                                            <th>Bill Address</th>
                                            <td>{customerData?.billaddress}</td>
                                        </tr>
                                        <tr>
                                            <th>Bill Country</th>
                                            <td>{customerData?.billCountryInfo?.country}</td>
                                        </tr>
                                        <tr>
                                            <th>Bill City</th>
                                            <td>{customerData?.billCityInfo?.city}</td>
                                        </tr>
                                        <tr>
                                            <th>Bill Zip Code</th>
                                            <td>{customerData?.billzipcode}</td>
                                        </tr>
                                        <tr>
                                            <th>Bill State</th>
                                            <td>{customerData?.billStateInfo?.state}</td>
                                        </tr> */}
                                            <tr>
                                                <th>Verified</th>
                                                <td>{`${customerData?.customer?.verified}`}</td>
                                            </tr>
                                            {/* <tr>
                                            <th>Profile Photo</th>
                                            <td>{customerData?.profilephoto}</td>
                                        </tr>
                                        <tr>
                                            <th>Ship Address</th>
                                            <td>{customerData?.shipaddress}</td>
                                        </tr>
                                        <tr>
                                            <th>Ship Country</th>
                                            <td>{customerData?.shipCountryInfo?.country}</td>
                                        </tr>
                                        <tr>
                                            <th>Ship City</th>
                                            <td>{customerData?.shipCityInfo?.city}</td>
                                        </tr>
                                        <tr>
                                            <th>Ship Zip Code</th>
                                            <td>{customerData?.shipzipcode}</td>
                                        </tr>
                                        <tr>
                                            <th>Ship State</th>
                                            <td>{customerData?.shipStateInfo?.state}</td>
                                        </tr> */}
                                            <tr>
                                                <th>Status</th>
                                                <td>{customerData?.customer?.statusInfo?.status}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <h4 className="text-primary h6 fw-bold">Customer Addresses</h4>
                            <div className="table-responsive">
                                <table className="table table-borderless table-hover">
                                    <thead>
                                        <tr>
                                            <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '100px' }} scope="col" width="80">
                                                <div className="tableHeadItems position-relative">
                                                    <span className="text-ellipsis">SR.</span>
                                                    <button className="filtBtn idFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                                </div>
                                            </th>
                                            <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '200px' }} scope="col">
                                                <div className="tableHeadItems position-relative">
                                                    <span className="text-ellipsis">Address Type</span>
                                                    <button className="filtBtn fNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                                </div>
                                            </th>
                                            <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '200px' }} scope="col">
                                                <div className="tableHeadItems position-relative">
                                                    <span className="text-ellipsis">Address</span>
                                                    <button className="filtBtn emailFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                                </div>
                                            </th>
                                            <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px' }} scope="col">
                                                <div className="tableHeadItems position-relative">
                                                    <span className="text-ellipsis">Address Landmark</span>
                                                </div>
                                            </th>
                                            {/* <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px'}}  scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Last Name</span>
                                        <button className="filtBtn lNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18}/></button>
                                    </div>
                                </th>
                                
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '200px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Designation</span>
                                        <button className="filtBtn emailFilter"><Icon className="arrowUp" icon={arrowUp} size={18}/></button>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Created Date</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Modified Date</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Created By</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Modified By</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Bill Address</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Bill Country</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Bill City</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Bill Zip Code</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Bill State</span>
                                    </div>
                                </th>
                                
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Profile Photo</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Ship Address</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Ship Country</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Ship City</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Ship Zip Code</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Ship State</span>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px'}} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Role</span>
                                    </div>
                                </th> */}
                                        </tr>
                                    </thead>
                                    <tbody className="table-group-divider">
                                        {
                                            customerData?.customerAddresses?.map((item, index) => (
                                                <tr key={item._id}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.addresstype}</td>
                                                    <td>{item.address}</td>
                                                    <td>{item.landmark}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
export default ViewCustomer;